import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface TableCardProps {
  children: ReactNode;
  className?: string;
}

export function TableCard({ children, className }: TableCardProps): JSX.Element {
  return (
    <div
      className={cn(
        "fx-tablecard bg-transparent",
        // The table's edge is DRAWN, not shaded. paper-to-white is 1.145 of
        // total range in light mode, so there is no room to separate the page,
        // the card and the header/footer by fill alone without darkening the
        // page — which was tried and read as muddy across every screen.
        // A border does the same job at no cost to the page: ink-200 is
        // 1.260 against the page where ink-100 was 1.085, i.e. present rather
        // than theoretical, and the shadow goes from 0.03 to a real lift so
        // the card sits ABOVE the canvas instead of being flush with it.
        "md:rounded-[var(--fx-r-lg)] md:border md:border-[var(--fx-ink-200)] md:bg-white md:shadow-[0_1px_2px_rgba(22,21,20,0.06),0_8px_20px_-12px_rgba(22,21,20,0.14)] md:overflow-hidden",
        // Dark needs the opposite treatment: a shadow does nothing on a dark
        // canvas, so the border carries the separation on its own.
        "dark:md:bg-[var(--dk-surface)] dark:md:border-[var(--dk-border-2)] dark:md:shadow-none",
        className
      )}
    >
      {children}
    </div>
  );
}
